<template>
    <div>
        <el-row :gutter="20">
            <el-col :lg="24" class="case-vote-temp">
                <template>
                    <el-tabs type="card" v-model="activeName" @tab-click="handleClick" class="cust-tabs">
                        <el-tab-pane name="stage_1">
                            <div slot="label" class="tab-panel">
                                <div class="tab-name">
                                    <p class="nm"> {{ $t("Case Details") }}</p>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="stage_2" v-if="$store.state.config.user.role_slug.indexOf('fachstellen') < 0 && caseDetails.status_key != 'stage_3' ">
                            <div slot="label" class="tab-panel">
                                <div class="tab-name">
                                    <p class="nm"> {{ $t("Vote Details") }}</p>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="stage_3" v-if="$store.state.config.user.role_slug==='main-admin' || $store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user'">
                            <div slot="label" class="tab-panel">
                                <div class="tab-name">
                                    <p class="nm"> {{ $t("Review Details") }}</p>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="17" :lg="18">
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <div class="case-detail-top-info">
                            <!-- <div class="case-det-image">
                                <span><img src="/static/member-avatar.jpg" alt="case-user-photo" /></span>
                            </div> -->
                            <div class="case-vote-detail">
                                <img src="/static/banner.jpg" alt="case-user-photo" />
                                <div class="case-name-info" v-if="caseDetails">
                                    <p class="case-nm">{{ caseDetails.patenkinder_nick_name }}</p>
                                    <!-- <p v-if="caseDetails.patenkinder_place !== null" >{{ caseDetails.patenkinder_place }}</p> -->
                                    <p v-date-format="caseDetails.patenkinder_dob"></p>
                                </div>
                                <div class="case-vote" v-if="caseDetails.status_key == 'stage_2' && $store.state.config.user.role_slug.indexOf('club') >= 0">
                                    <p>{{$t('Give Your Vote')}}</p>
                                    <div class="both-icons">
                                        <a href="javascript:void(0);" :class="{ 'up-vote': true, active: voteDetails.self_vote == 'up' }" @click="makeVote('up')">
                                            <i class="icon-up-votes"></i>
                                        </a>
                                        <a href="javascript:void(0);" :class="{ 'down-vote': true, active: voteDetails.self_vote == 'down' }" @click="makeVote('down')">
                                            <i class="icon-down-votes"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="total-vote-info" v-if="voteDetails.total_voters >= 0">
                                    <div class="progress-row">
                                        <label for="">{{ $t('Total voters1') }}</label>
                                        <el-progress :percentage="100" :show-text="false"></el-progress>
                                        <span>{{ voteDetails.total_voters }}</span>
                                    </div>
                                    <div class="progress-row">
                                        <label for="">{{ $t('Agree') }}</label>
                                        <el-progress class="agree-progress" :percentage="(voteDetails.up_votes / voteDetails.total_voters * 100)" :show-text="false"></el-progress>
                                        <span>{{ voteDetails.up_votes }}</span>
                                    </div>
                                    <div class="progress-row">
                                        <label for="">{{ $t('Not agree') }}</label>
                                        <el-progress class="not-agree-progress" :percentage="(voteDetails.down_votes / voteDetails.total_voters * 100)" :show-text="false"></el-progress>
                                        <span>{{ voteDetails.down_votes }}</span>
                                    </div>
                                    <div class="progress-row">
                                        <label for="">{{ $t('In discussion') }}</label>
                                        <el-progress class="disc-progress" :percentage="(voteDetails.discussion_count / voteDetails.total_voters * 100)" :show-text="false"></el-progress>
                                        <span>{{ voteDetails.discussion_count }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col class="abouteCaseDetail" :xs="24" :sm="6" :md="7" :lg="6">
                        <div class="header">
                            <h1>{{ $t('About case') }}</h1>
                        </div>
                        <el-card class="about-card">
                            <div class="card-row">
                                <div class="left-border-list">
                                    <h3>{{ $t('Title') }}</h3>
                                    <p>{{ caseDetails.case_title }}</p>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Created on') }}</h3>
                                    <p v-date-time-format="caseDetails.created_at"></p>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Expected amount') }}</h3>
                                    <p>{{ caseDetails.expected_amount | currency-format }}</p>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Fachstellen name') }}</h3>
                                    <p>{{ caseDetails.fachstellen_name }}</p>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Description Of The Application') }}</h3>
                                    <p>{{ caseDetails.description }}</p>
                                </div>
                            </div>
                        </el-card>
                        <!-- General needs of the child section -->
                        <!-- <div class="header" v-if="caseDetails.description">
                            <h1>{{ $t('Description of the application') }}</h1>
                        </div>
                        <el-card class="about-card" v-if="caseDetails.description">
                            <div class="card-row">
                                <div class="left-border-list">
                                    <p v-html="$options.filters.nl2br(caseDetails.description)"></p>
                                </div>
                            </div>
                        </el-card> -->
                    </el-col>
                    <el-col :xs="24" :sm="18" :md="17" :lg="18">
                        <el-row v-if="caseDetails.status_key == 'stage_2'">
                            <el-col>
                                <div class="header">
                                    <h1>{{$t("Discussion")}}</h1>
                                </div>
                                <el-card class="box-card comment-box">
                                    <div class="avatar-dev">
                                        <span class="avatar-icon">
                                            <img :src="$store.state.config.user.profile_image || '/static/default_user.svg'" alt="user-avatar" />
                                        </span>
                                    </div>
                                    <el-form ref="commentForm" :model="commentForm" id="commentForm">
                                        <el-form-item prop="commentDesc" :rules="[{ required: true, message: $t('This field is required')}]" class="comment-textbox">
                                            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" :placeholder="$t('What\'s on your mind?')" v-model="commentForm.commentDesc"></el-input>
                                        </el-form-item>
                                        <el-form-item class="btn-add-comment">
                                            <el-button size="mini" type="primary" @click="addComment('commentForm')">
                                                {{$t("Add comment")}}
                                            </el-button>
                                        </el-form-item>
                                    </el-form>
                                </el-card>
                            </el-col>
                        </el-row>
                        <el-row v-if="caseComments.length > 0">
                            <el-col id="comment-sec">
                                <el-card class="box-card reply-box" v-for="(caseComment) in caseComments" :key="caseComment.id">
                                    <el-dropdown @command="handleCommand" class="operations" trigger="click" v-if="caseDetails.status_key == 'stage_2' && ((caseComment.user_id == $store.state.config.user.id) || ($store.state.config.user.role_id == 1))">
                                        <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item :command="{type:'edit', row: caseComment}"><i class="el-icon-edit"></i>
                                                {{ $t('Edit') }}</el-dropdown-item>
                                            <el-dropdown-item :command="{type:'delete', row: caseComment}"><i class="el-icon-delete"></i>
                                                {{ $t('Delete') }}</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <div class="avatar-dev">
                                        <span class="avatar-icon">
                                            <img :src="caseComment.profile_image || '/static/default_user.svg'" alt="user-avatar" />
                                        </span>
                                        <p class="user-name">{{ caseComment.user_name }} <span class="comment-duration" v-date-time-format="caseComment.created_at"></span></p>
                                    </div>
                                    <div class="comment-div">
                                        <el-input v-if="caseComment.edit" type="textarea" v-model="caseComment.comment"></el-input>
                                        <p v-else v-html="$options.filters.nl2br(caseComment.comment)"></p>
                                        <div class="replied-box">
                                            <el-button v-if="caseComment.edit" type="success" @click="confirmEdit(caseComment)" size="mini" icon="el-icon-check" circle></el-button>
                                            <el-button v-if="caseComment.edit" class='cancel-btn' size="mini" icon="el-icon-close" type="warning" @click="cancelEdit(caseComment)" circle></el-button>
                                        </div>
                                    </div>
                                    <div class="reply-comments" v-if="caseComment.children">
                                        <el-card class="box-card" v-for="commentReply in caseComment.children" :key="commentReply.id">
                                            <div class="comment-box">
                                                <el-dropdown @command="handleCommand" class="operations" trigger="click" v-if="caseDetails.status_key == 'stage_2' && ((commentReply.user_id == $store.state.config.user.id) || ($store.state.config.user.role_id == 1))">
                                                    <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item :command="{type:'edit', row: commentReply}"><i class="el-icon-edit"></i>
                                                            {{ $t('Edit') }}</el-dropdown-item>
                                                        <el-dropdown-item :command="{type:'delete', row: commentReply}"><i class="el-icon-delete"></i>
                                                            {{ $t('Delete') }}</el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                                <div class="avatar-dev">
                                                    <span class="avatar-icon">
                                                        <img :src="commentReply.profile_image || '/static/default_user.svg'" alt="user-avatar" />
                                                    </span>
                                                    <p class="user-name">{{ commentReply.user_name }} <span class="comment-duration" v-date-time-format="commentReply.created_at"></span></p>
                                                </div>
                                                <div class="comment-div">
                                                    <span>
                                                        <el-input v-if="commentReply.edit" type="textarea" v-model="commentReply.comment"></el-input>
                                                        <p v-else v-html="$options.filters.nl2br(commentReply.comment)"></p>
                                                        <div class="replied-box">
                                                            <el-button v-if="commentReply.edit" type="success" @click="confirmEdit(commentReply)" size="mini" icon="el-icon-check" circle></el-button>
                                                            <el-button v-if="commentReply.edit" class='cancel-btn' size="mini" icon="el-icon-close" type="warning" @click="cancelEdit(commentReply)" circle></el-button>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </el-card>
                                    </div>
                                    <a v-if="caseDetails.status_key == 'stage_2'" href="javascript:void(0)" @click="caseComment.reply = !caseComment.reply" class="reply-link">{{
                                        $t('Reply') }}</a>
                                    <div class="replyForm" v-if="caseComment.reply == true">
                                        <el-form :ref="'replyForm-'+caseComment.id" :model="caseComment.replyForm" id="replyForm">
                                            <el-form-item prop="commentDesc" :rules="[{ required: true, message: $t('This field is required')}]">
                                                <el-input type="textarea" autosize :placeholder="$t('Want to reply?')" v-model="caseComment.replyForm.commentDesc"></el-input>
                                            </el-form-item>
                                            <el-form-item class="btn-add-comment" style="padding-top:10px">
                                                <el-button size="mini" type="primary" @click="addReply('replyForm-'+caseComment.id, caseComment.children, caseComment.replyForm)">{{$t('Post')}}</el-button>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>
                        <el-row v-else>
                            <el-col id="comment-sec">
                                <el-card class="box-card reply-box">
                                    <p>{{ $t('There is no discussion started.') }}</p>
                                </el-card>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="7" :lg="6">
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" v-if="caseDetails.org_description">
                        <div class="header" style="padding-left: 5px;">
                            <h4 style="border-left: 0;"><i class="el-icon-info"></i> &nbsp;{{ $t("Voting note") }}</h4>
                        </div>
                        <el-card class="box-card comment-box">
                            <p v-html="$options.filters.nl2br(caseDetails.org_description)"></p>
                        </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" v-if="caseDetails.fachstellen_data">
                        <div class="header">
                            <h1>{{ $t('Fachstellen details') }}</h1>
                        </div>
                        <el-card class="fasch-detail">
                            <div class="info">
                                <p>{{ caseDetails.fachstellen_data.display_name }}</p>
                                <span>{{ caseDetails.fachstellen_data.address }}</span>
                                <span>{{ caseDetails.fachstellen_data.place }}</span>
                                <span>{{ caseDetails.fachstellen_data.zipcode }}</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" v-if="voteDetails.all_voter_details && voteDetails.all_voter_details.length">
                        <div class="header">
                            <h1>{{ $t('Club member details') }}</h1>
                        </div>
                        <el-card class="member-card">
                            <el-alert :title="$t('Note:')" type="warning" :description="$t('Click on member image to see his/her remarks')" show-icon style="margin-bottom: 10px">
                            </el-alert>
                            <div class="member-dev" v-for="clubMember in voteDetails.all_voter_details" :key="clubMember.id">
                                <el-popover placement="bottom" :title="$t('Comments')" width="200" trigger="click"
                                    :content="clubMember.remark" v-if="clubMember.remark">
                                    <div class="member-img" slot="reference">
                                        <img :src="clubMember.profile_image || '/static/default_user.svg'" alt="member-avatar" />
                                        <span :class="(clubMember.vote_type == 'up'?'v-up':(clubMember.vote_type == 'down')?'v-down':'v-hold')"></span>
                                    </div>
                                </el-popover>
                                <div class="member-img" slot="reference" v-else>
                                    <img :src="clubMember.profile_image || '/static/default_user.svg'" alt="member-avatar" />
                                    <span :class="(clubMember.vote_type == 'up'?'v-up':(clubMember.vote_type == 'down')?'v-down':'v-hold')"></span>
                                </div>
                                <p>{{ clubMember.display_name }}</p>
                                <p>{{ clubMember.club_name }}</p>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-dialog :title="$t('Comments')" :visible.sync="voteRemarksDialog">
            <el-form :model="voteRemarkForm" ref="voteRemarkForm" :rules="voteRules" class="remarks-form">
                <el-form-item :label="$t('Comments')" prop="remark" class="remark-input">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" v-model="voteRemarkForm.remark"></el-input>
                </el-form-item>
                <el-form-item class="remark-action">
                    <el-button type="primary" :loading="isLoading" @click="voteRemark('voteRemarkForm', 'save')">{{$t('Add Remark')}}</el-button>
                    <el-button type="danger" style="padding: 12px 20px;" :loading="isLoading" @click="voteRemark('voteRemarkForm', 'skip')">{{$t('Skip')}}</el-button>
                    <el-button type="cancel" @click="voteRemarksDialog = false">{{$t('Cancel')}}</el-button>
                </el-form-item>
                <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
            </el-form>
        </el-dialog>
    </div>

</template>
<script>
    import EnjoyHint from 'enjoyhint';

    export default {
        data() {
            return {
                voteDetails: {},
                activeName: 'stage_2',
                commentForm: {},
                caseComments: {},
                socket: null,
                currentRow: {},
                dummyRow: {},
                caseDetails: {},
                showTabs: false,
                voteRemarksDialog: false,
                voteRemarkForm: {
                    remark: '',
                    patenkinder_case_id: this.$route.params.id
                },
                isLoading: false,
                isRemarkRequired: false,
                enjoyhint_instance: null
            };
        },
        computed: {
            voteRules() {
                return { 
                    remark: [{ 
                        required: this.isRemarkRequired, 
                        message: this.$t('This field is required'),
                    }]
                }
            }
        },
        mounted() {
            serverBus.$on("runHelpTour", status => {
                if(status && this.caseDetails.status_key == 'stage_2') {
                    this.runEnjoyHint();
                } 
            });            
            request({
                    url: "patenkinder-cases/" + this.$route.params.id,
                    method: "get",
                    params: {}
                })
                .then(response => {
                    this.caseDetails = response.data.data;
                    if(this.caseDetails.status_key != 'stage_2') {
                        serverBus.$emit('showHelp', false);
                    }
                });
            request({
                    url: "case-vote-details/" + this.$route.params.id,
                    method: "get"
                })
                .then(response => {
                    this.voteDetails = response.data.data;
                    this.showTabs = true;
                });
            request({
                    url: "case/" + this.$route.params.id + "/comments",
                    method: "get"
                })
                .then(response => {
                    this.caseComments = response.data.data;
                    this.setEditAtt();
                });
            this.socket = io(process.env.KIPAKI_SOCKET_URL, {
                reconnectionAttempts: 1,
            });
            this.socket.on(`case_${this.$route.params.id}:App\\Events\\CaseComment\\CaseCommentAdded`, data => {
                if (data.commentData.parent_id == null) {
                    this.caseComments.unshift(Object.assign({}, data.commentData));
                } else {
                    this.caseComments.forEach((row, i) => {
                        if (row.id == data.commentData.parent_id) {
                            row.children.push(Object.assign({}, data.commentData));
                        }
                    });
                }
                this.setEditAtt();
            });
            this.socket.on(`case_${this.$route.params.id}:App\\Events\\CaseComment\\CaseCommentUpdated`, data => {
                if (data.commentData.parent_id == null) {
                    this.caseComments = this.caseComments.map((row, i) => {
                        if (row.id == data.commentData.id) {
                            row = data.commentData;
                        }
                        return row;
                    });
                } else {
                    this.caseComments = this.caseComments.map((row) => {
                        if (row.id == data.commentData.parent_id && row.children.length > 0) {
                            row.children = row.children.map((childrow) => {
                                if (childrow.id == data.commentData.id) {
                                    childrow = data.commentData;
                                }
                                return childrow;
                            });
                        }
                        return row;
                    });
                }
                this.setEditAtt();
            });
            this.socket.on(`case_${this.$route.params.id}:App\\Events\\CaseComment\\CaseCommentDeleted`, data => {
                if (data.commentData.parent_id == null) {
                    this.caseComments = this.caseComments.filter((row, i) => {
                        return row.id != data.commentData.id;
                    });
                } else {
                    this.caseComments = this.caseComments.filter((res) => {
                        if (res.children.length > 0 && data.commentData.id != res.id) {
                            res.children = res.children.filter((child) => {
                                return child.id != data.commentData.id
                            });
                        }
                        return res.id != data.commentData.id;
                    });
                }
                this.setEditAtt();
            });
        },
        created(){
            this.$nextTick(function () {
                // Code that will run only after the
                // entire view has been re-rendered
                if(this.$store.state.config.user.role_slug.indexOf('club') >= 0 && 
                    this.$store.state.config.user.tour_visited == '0') {
                    setTimeout(function() {
                        if(this.caseDetails.status_key == 'stage_2') { 
                            this.runEnjoyHint();
                        }
                    }.bind(this), 1000);
                }
            })
        },
        methods: {
            setEditAtt() {
                this.caseComments = this.caseComments.map(v => {
                    this.$set(v, 'edit', false);
                    this.$set(v, 'reply', false);
                    this.$set(v, 'replyForm', {
                        id: v.id,
                        commentDesc: null
                    });
                    if (v.children.length > 0) {
                        v.children.map(c => {
                            this.$set(c, 'edit', false)
                            return c
                        });
                    }
                    return v
                });
            },
            handleClick(tab, event) {
                if (tab.name == "stage_1") {
                    this.$router.push({
                        name: 'CaseDetails',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                } else if (tab.name == "stage_2") {
                    this.$router.push({
                        name: 'CaseVoting',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'CaseReview',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                }
            },
            makeVote(type) {
                if( this.voteDetails.self_vote != type ) {
                    this.voteRemarksDialog = true
                    this.voteRemarkForm.vote_type = type
                    // this.enjoyhint_instance.trigger('next');
                } else {
                    request({
                        url: "vote-patenkinder-case",
                        method: "post",
                        data: {
                            patenkinder_case_id: this.$route.params.id,
                            vote_type: type,
                            remark: ''
                        }
                    })
                    .then(response => {
                        this.voteDetails = response.data.data;
                        this.$notify({
                            title: this.$t('Success'),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
                }
            },
            voteRemark(formName, flag) {
                if(flag == 'skip') {
                    this.voteRemarkForm.remark = '';
                    this.isRemarkRequired = false;
                } else {                    
                    this.isRemarkRequired = true;
                }
                setTimeout(function() {
                    this.addVoteRemarks(formName);
                }.bind(this), 500);
                
            },
            addVoteRemarks(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        request({
                            url: "vote-patenkinder-case",
                            method: "post",
                            data: this.voteRemarkForm
                        })
                        .then(response => {
                            this.voteDetails = response.data.data;
                            this.isLoading = false;
                            this.voteRemarksDialog = false;
                            this.voteRemarkForm.remark = '';
                            this.$notify({
                                title: this.$t('Success'),
                                message: response.data.message,
                                type: "success",
                                offset: 50
                            });
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.$notify({
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                        });                        
                    }
                });
            },
            addComment(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        request({
                                url: "case/" + this.$route.params.id + "/comments",
                                method: "post",
                                data: {
                                    comment: this.commentForm.commentDesc
                                }
                            })
                            .then(response => {
                                let commentData = response.data.data;
                                // this.enjoyhint_instance.trigger('next');
                            });
                        this.$refs[formName].resetFields();
                    }
                });
            },
            addReply(formName, replyData, formData) {
                this.$refs[formName][0].validate(valid => {
                    if (valid) {
                        request({
                                url: "case/" + this.$route.params.id + "/comments",
                                method: "post",
                                data: {
                                    comment: formData.commentDesc,
                                    parent_id: formData.id
                                }
                            })
                            .then(response => {
                                this.enjoyhint_instance.trigger('next');
                            });
                        this.$refs[formName][0].resetFields();
                    }
                });
            },
            cancelEdit(row) {
                row.edit = false;
                Object.assign(row, this.currentRow);
            },
            confirmEdit(row) {
                row.edit = false
                request({
                    url: "case/" + this.$route.params.id + "/comments/" + row.id,
                    method: "PATCH",
                    data: row
                }).then(response => {}).catch(error => {
                    this.$notify({
                        title: this.$t('Error'),
                        message: error.response.data.message,
                        type: "error",
                        offset: 50
                    });
                });
            },
            deleteComment(row) {
                this.$confirm(
                    this.$t('Are you sure want to delete this comment?'),
                    this.$t('Warning'), {
                        confirmButtonText: this.$t('Yes'),
                        cancelButtonText: this.$t('No'),
                        type: "warning",
                        cancelButtonClass: "el-button--cancel",
                        confirmButtonClass: "el-button--primary"
                    }
                ).then(() => {
                    request({
                            url: "case/" + this.$route.params.id + "/comments/" + row.id,
                            method: "delete",
                            data: {}
                        })
                        .then(response => {})
                        .catch(error => {});
                });
            },
            handleCommand(command) {
                if (command.type == 'edit') {
                    this.cancelEdit(this.dummyRow)
                    this.currentRow = Object.assign({}, command.row);
                    this.dummyRow = command.row;
                    command.row.edit = !command.row.edit;
                } else if (command.type == 'delete') {
                    this.deleteComment(command.row);
                }
            },
            runEnjoyHint() {
                var options = {
                };
                this.enjoyhint_instance = new EnjoyHint(options);
                var enjoyhint_script_steps = [];

                    if (this.$store.state.config.user.role_slug.indexOf('club') >= 0) {
                        if (this.voteDetails.self_vote == 'up') {
                            enjoyhint_script_steps.push({
                                selector: '.down-vote',//jquery selector
                                event: 'click',
                                description: this.$t('Click icon to give your vote'),
                                scrollAnimationSpeed: 100,
                                "nextButton" : {className: "", text: this.$t("Next")},
                                "skipButton" : {className: "", text: this.$t("Skip")},
                            });
                        } else if(this.voteDetails.self_vote == 'down') {
                            enjoyhint_script_steps.push({
                                selector: '.up-vote',//jquery selector
                                event: 'click',
                                description: this.$t('Click icon to give your vote'),
                                scrollAnimationSpeed: 100,
                                "nextButton" : {className: "", text: this.$t("Next")},
                                "skipButton" : {className: "", text: this.$t("Skip")},
                            });
                        } else {
                            enjoyhint_script_steps.push({
                                selector: '.both-icons',//jquery selector
                                event: 'click',
                                description: this.$t('Click any icon to give your vote'),
                                scrollAnimationSpeed: 100,
                                "nextButton" : {className: "", text: this.$t("Next")},
                                "skipButton" : {className: "", text: this.$t("Skip")},
                            });
                        }
                        enjoyhint_script_steps.push({
                            selector: '.remark-input',//jquery selector
                            showNext: true,
                            description: this.$t('Add remarks here if you want'),
                            "nextButton" : {className: "", text: this.$t("Next")},
                            "skipButton" : {className: "", text: this.$t("Skip")},
                        }, {
                            selector: '.remark-action',//jquery selector
                            event: 'click',
                            description: this.$t('Press "Add Remarks" to Add Remarks <br /> Press "Skip" if you don\'t want to add voting remarks'),
                            "nextButton" : {className: "", text: this.$t("Next")},
                            "skipButton" : {className: "", text: this.$t("Skip")},
                        }, {
                            selector: '.member-card',//jquery selector
                            showNext: true,
                            description: this.$t('Click on your image to see your remarks, if you have added'),
                            onBeforeStart: function(){
                                //do something
                                this.voteRemarksDialog = false;
                            }.bind(this),
                            scrollAnimationSpeed: 370,
                            "nextButton" : {className: "", text: this.$t("Next")},
                            "skipButton" : {className: "", text: this.$t("Skip")},
                        });
                    }
                    enjoyhint_script_steps.push({
                        selector: '#commentForm',//jquery selector                     
                        event_type: 'key',
                        keyCode: '#commentForm .el-button--primary',
                        description: this.$t('Enter Comment and press "Add Comment" button'),
                        scrollAnimationSpeed: 270,
                        "nextButton" : {className: "", text: this.$t("Next")},
                        "skipButton" : {className: "", text: this.$t("Skip")},
                    },
                    {
                        selector: '#comment-sec .el-card__body:first-child .comment-div',//jquery selector
                        event: 'next',
                        showNext: true,
                        description: this.$t('Comment added is shown here'),
                        scrollAnimationSpeed: 450,
                        "nextButton" : {className: "", text: this.$t("Next")},
                        "skipButton" : {className: "", text: this.$t("Skip")},
                        // timeout: 2500
                    }, {
                        selector: '#comment-sec .el-card__body:first-child .reply-link',//jquery selector
                        event: 'click',
                        description: this.$t('Click "Reply" to reply over a comment'),
                        scrollAnimationSpeed: 450,
                        "nextButton" : {className: "", text: this.$t("Next")},
                        "skipButton" : {className: "", text: this.$t("Skip")},
                    }, {
                        selector: '#comment-sec .el-card__body:first-child .replyForm #replyForm',//jquery selector
                        event_type: 'key',
                        keyCode: '#comment-sec .el-card__body:first-child .replyForm .el-button',
                        description: this.$t('Enter reply message and press "Post" Button'),
                        scrollAnimationSpeed: 450,
                        "nextButton" : {className: "", text: this.$t("Next")},
                        "skipButton" : {className: "", text: this.$t("Skip")},
                    }, {
                        selector: '#comment-sec .el-card__body:first-child .reply-comments .el-card__body:last-child',//jquery selector
                        // event_type: 'key',
                        event: 'next',
                        description: this.$t('Your reply will be shown here'),
                        // timeout: 2500
                        scrollAnimationSpeed: 450,
                        "skipButton" : {className: "", text: this.$t("Get Started")},
                    });
                     //set script config
                    this.enjoyhint_instance.set(enjoyhint_script_steps);

                // Below block will only be executed if user has visited the tour first time.
                if(this.$store.state.config.user.tour_visited == '0') {
                    var user_id = this.$store.state.config.user.id;
                    var user_details = this.$store.state.config.user;
                    user_details.tour_visited = '1';

                    // Update tour visited status on skip button click
                    $('.enjoyhint_skip_btn').on('click', function () {
                        helper.updateTourVisited(user_id).then(() => {
                            
                            this.$store.dispatch("setConfig", {
                                user: user_details
                            });
                        });
                    }.bind(this));

                    // Update tour visited status on next button click
                    $('.enjoyhint_next_btn').on('click', function () {
                        helper.updateTourVisited(user_id).then(() => {
                            this.$store.dispatch("setConfig", {
                                user: user_details
                            });
                        });
                    }.bind(this));
                }

                //run Enjoyhint script
                this.enjoyhint_instance.run();
            }
        }
    }

</script>
<style>
    .comment-div button i {
        font-size: 20px;
        padding: 0px;
    }
    .enjoyhint {
        z-index: 2010;
    }

</style>

<style scoped>
    .avatar-icon {
        height: 35px;
        width: 35px;
        display: block;
        vertical-align: top;
        border-radius: 100%;
        overflow: hidden;
        border: 2px solid #ccc;
    }

    .avatar-icon img {
        max-width: 100%;
        min-height: 31px;
    }

    .reply-comments {
        width: 100%;
        overflow: auto;
    }

    .reply-comments .box-card {
        width: 95%;
        float: right;
    }

    .replyForm {
        width: 100%;
        display: inline-block;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .operations {
        transform: rotate(90deg);
        position: absolute;
        right: 6px;
        top: 12px;
        padding: 10px;
        cursor: pointer;
        color: #616161;
    }

    .operations i {
        font-size: 118.75%;
    }

</style>



// WEBPACK FOOTER //
// src/components/Layout/Cases/CaseVoting.vue